// extracted by mini-css-extract-plugin
export default {"navButton":"NavFooter_navButton__SMVcH"};